"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = require("react");
var util_1 = require("./util");
var useElementRef_1 = require("./useElementRef");
var usePopover = function (_a) {
    var childRef = _a.childRef, positions = _a.positions, containerClassName = _a.containerClassName, containerParent = _a.containerParent, contentLocation = _a.contentLocation, align = _a.align, padding = _a.padding, reposition = _a.reposition, boundaryInset = _a.boundaryInset, onPositionPopover = _a.onPositionPopover;
    var popoverRef = useElementRef_1.useElementRef(containerClassName, {
        position: 'fixed',
        overflow: 'visible',
        top: '0px',
        left: '0px',
    });
    var positionPopover = react_1.useCallback(function (positionIndex, childRect, popoverRect, parentRect) {
        var _a;
        if (positionIndex === void 0) { positionIndex = 0; }
        if (childRect === void 0) { childRect = (_a = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(); }
        if (popoverRect === void 0) { popoverRect = popoverRef.current.getBoundingClientRect(); }
        if (parentRect === void 0) { parentRect = containerParent === null || containerParent === void 0 ? void 0 : containerParent.getBoundingClientRect(); }
        if (!childRect || !parentRect) {
            return;
        }
        if (contentLocation) {
            var _b = typeof contentLocation === 'function'
                ? contentLocation({
                    childRect: childRect,
                    popoverRect: popoverRect,
                    parentRect: parentRect,
                    position: 'custom',
                    align: 'custom',
                    padding: padding,
                    nudgedTop: 0,
                    nudgedLeft: 0,
                    boundaryInset: boundaryInset,
                })
                : contentLocation, inputTop = _b.top, inputLeft = _b.left;
            var left_1 = parentRect.left + inputLeft;
            var top_1 = parentRect.top + inputTop;
            popoverRef.current.style.transform = "translate(" + left_1 + "px, " + top_1 + "px)";
            onPositionPopover({
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                position: 'custom',
                align: 'custom',
                padding: padding,
                nudgedTop: 0,
                nudgedLeft: 0,
                boundaryInset: boundaryInset,
            });
            return;
        }
        var isExhausted = positionIndex === positions.length;
        var position = isExhausted ? positions[0] : positions[positionIndex];
        var _c = util_1.getNewPopoverRect({
            childRect: childRect,
            popoverRect: popoverRect,
            parentRect: parentRect,
            position: position,
            align: align,
            padding: padding,
            reposition: reposition,
        }, boundaryInset), rect = _c.rect, boundaryViolation = _c.boundaryViolation;
        if (boundaryViolation && reposition && !isExhausted) {
            positionPopover(positionIndex + 1, childRect, popoverRect, parentRect);
            return;
        }
        var top = rect.top, left = rect.left, width = rect.width, height = rect.height;
        var shouldNudge = reposition && !isExhausted;
        var _d = util_1.getNudgedPopoverRect(rect, parentRect, boundaryInset), nudgedLeft = _d.left, nudgedTop = _d.top;
        var finalTop = top;
        var finalLeft = left;
        if (shouldNudge) {
            finalTop = nudgedTop;
            finalLeft = nudgedLeft;
        }
        popoverRef.current.style.transform = "translate(" + finalLeft + "px, " + finalTop + "px)";
        onPositionPopover({
            childRect: childRect,
            popoverRect: {
                top: finalTop,
                left: finalLeft,
                width: width,
                height: height,
                right: finalLeft + width,
                bottom: finalTop + height,
            },
            parentRect: parentRect,
            position: position,
            align: align,
            padding: padding,
            nudgedTop: nudgedTop - top,
            nudgedLeft: nudgedLeft - left,
            boundaryInset: boundaryInset,
        });
    }, [
        childRef,
        popoverRef,
        positions,
        align,
        padding,
        reposition,
        boundaryInset,
        containerParent,
        contentLocation,
        onPositionPopover,
    ]);
    return [positionPopover, popoverRef];
};
exports.usePopover = usePopover;
//# sourceMappingURL=data:application/json;base64,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